import React from "react";
import state from "../state";
import { useSnapshot } from "valtio";

const options = [
    {
        name: "legs",
        img:"https://s3-us-west-2.amazonaws.com/s.cdpn.io/1376484/legs.svg"},
    {
        name:"cushions",
        img: "https://s3-us-west-2.amazonaws.com/s.cdpn.io/1376484/cushions.svg"},
    {
        name:"base",
        img:"https://s3-us-west-2.amazonaws.com/s.cdpn.io/1376484/base.svg"},
    {
        name:"supports",
        img: "https://s3-us-west-2.amazonaws.com/s.cdpn.io/1376484/supports.svg"},
    {
        name:"back",
        img: "https://s3-us-west-2.amazonaws.com/s.cdpn.io/1376484/back.svg"},
    ]

export const OptionsMenu = ({activeOption, setActiveOption}) => {
    const snap = useSnapshot(state);
    return(
        <div className="options">
            {options.map(({name, img}, idx) => (
                <div
                    className={`option ${activeOption === name ? "--is-active" : ""}`}
                    data-option={name}
                    onMouseEnter={() => state.hoveredType = name}
                    onMouseLeave={() => snap.hoveredType === name ? state.hoveredType = null : null}
                    onClick={() => setActiveOption(name)}
                    key={name}
                >
                    <img src={img} alt=""/>
                </div>
            ))}
        </div>
    )
}